import ApiClient from './ApiClient';

class ScheduledReportsAPI extends ApiClient {
  constructor() {
    super('scheduled_reports', { accountScoped: true });
  }
}

export default new ScheduledReportsAPI();
